import { IBybitPosition } from "../../interfaces/bybit";
import { IAggregatedPosition } from "../../interfaces/positions";
import { convertToAevoAssetName } from "../assetNameMappings";

export const retrieveBybitAssetBySymbol = (symbol: string) =>
  // Bybit symbols are like BTCUSDT, ETHUSDT, 1000BONKUSDT, 1000000MOGUSDT, etc.
  // Simply remove USDT suffix, keep numeric prefixes as they're part of the asset name
   symbol.replace("USDT", "");
export const standardizeBybitPositions = (
  positions: Partial<IBybitPosition>[]
): IAggregatedPosition[] => {
  const standardizedPositions: Record<string, IAggregatedPosition> = {};

  positions.forEach((pos) => {
    if (pos.symbol && pos.size) {
      const bybitAsset = retrieveBybitAssetBySymbol(pos.symbol);
      // Convert to Aevo asset name for proper aggregation
      const aevoAsset = convertToAevoAssetName(bybitAsset, "bybit");
      const bybitInstrumentName = `${aevoAsset}-PERPETUAL`;

      // Bybit uses "Buy" for long and "Sell" for short
      const positionSize = pos.side === "Sell" ? -Number(pos.size) : Number(pos.size);

      standardizedPositions[bybitInstrumentName] = {
        instrument_name: bybitInstrumentName,
        asset: aevoAsset,
        side: positionSize > 0 ? "buy" : "sell",
        delta: positionSize,
        contracts: positionSize,
        gamma: 0,
        vega: 0,
        theta: 0,
        pnl: Number(pos.unrealisedPnl || 0),
        isPerpetual: true,
        source: "Bybit",
        bybitDelta: positionSize,
        bybitMarkPrice: Number(pos.markPrice || 0),
      };
    }
  });

  return Object.values(standardizedPositions);
};
